// extracted by css-extract-rspack-plugin
export default {"value":"Value-module__value___qPjtq","animatedGradient":"Value-module__animatedGradient___cIOFb"};